<template>
  <div>
    <v-navigation-drawer v-model="drawer" app class="drawer">
      <v-row class="ma-0">

        <!-- Logo + User Info -->
        <v-col class="col-12 pa-6 text-center" style="background: #f8f9fa;">
          <v-avatar size="100" color="transparent">
            <img src="../assets/circle.png" width="180" style="object-fit: contain;" />
          </v-avatar>
          <div class="mt-4">
            <div class="text-h6 font-weight-bold">{{ userName }}</div>
            <v-chip small color="#008080" dark class="mt-2 px-4">
              {{ userRole || 'Admin' }}
            </v-chip>
          </div>
        </v-col>

        <!-- Menu Items -->
        <v-col class="pa-0">
          <v-list-item-group v-model="clickedItem" color="#008080">

            <!-- SUPER ADMIN SEES EVERYTHING -->
            <template v-if="isSuperAdmin">
              <v-list-item @click="menuActionClick('dashboard')">
                <v-list-item-icon><v-icon>mdi-view-dashboard</v-icon></v-list-item-icon>
                <v-list-item-content><v-list-item-title>Dashboard</v-list-item-title></v-list-item-content>
              </v-list-item>

              <v-list-item @click="menuActionClick('properties')">
                <v-list-item-icon><v-icon>mdi-home-city</v-icon></v-list-item-icon>
                <v-list-item-content><v-list-item-title>Properties</v-list-item-title></v-list-item-content>
              </v-list-item>

              <v-list-item @click="menuActionClick('lease')">
                <v-list-item-icon><v-icon>mdi-file-document-outline</v-icon></v-list-item-icon>
                <v-list-item-content><v-list-item-title>Leases</v-list-item-title></v-list-item-content>
              </v-list-item>

              <v-list-item @click="menuActionClick('tenants')">
                <v-list-item-icon><v-icon>mdi-account-group</v-icon></v-list-item-icon>
                <v-list-item-content><v-list-item-title>Tenants</v-list-item-title></v-list-item-content>
              </v-list-item>

              <v-list-item @click="menuActionClick('landlords')">
                <v-list-item-icon><v-icon>mdi-account-tie</v-icon></v-list-item-icon>
                <v-list-item-content><v-list-item-title>Landlords</v-list-item-title></v-list-item-content>
              </v-list-item>

              <v-list-item @click="menuActionClick('activities')">
                <v-list-item-icon><v-icon>mdi-history</v-icon></v-list-item-icon>
                <v-list-item-content><v-list-item-title>Activities</v-list-item-title></v-list-item-content>
              </v-list-item>

              <v-list-item @click="menuActionClick('LeaseReports')">
                <v-list-item-icon><v-icon>mdi-chart-line</v-icon></v-list-item-icon>
                <v-list-item-content><v-list-item-title>Reports</v-list-item-title></v-list-item-content>
              </v-list-item>

          
              <v-list-item @click="menuActionClick('Users')">
                <v-list-item-icon><v-icon>mdi-shield-account</v-icon></v-list-item-icon>
                <v-list-item-content><v-list-item-title>Users</v-list-item-title></v-list-item-content>
              </v-list-item>
            </template>

            <!-- NORMAL ADMIN SEES LIMITED MENU -->
            <template v-else>
              <v-list-item @click="menuActionClick('dashboard')">
                <v-list-item-icon><v-icon>mdi-view-dashboard</v-icon></v-list-item-icon>
                <v-list-item-content><v-list-item-title>Dashboard</v-list-item-title></v-list-item-content>
              </v-list-item>

              <v-list-item @click="menuActionClick('lease')">
                <v-list-item-icon><v-icon>mdi-file-document-outline</v-icon></v-list-item-icon>
                <v-list-item-content><v-list-item-title>Leases</v-list-item-title></v-list-item-content>
              </v-list-item>

              <v-list-item @click="menuActionClick('tenants')">
                <v-list-item-icon><v-icon>mdi-account-group</v-icon></v-list-item-icon>
                <v-list-item-content><v-list-item-title>Tenants</v-list-item-title></v-list-item-content>
              </v-list-item>

              <v-list-item @click="menuActionClick('landlords')">
                <v-list-item-icon><v-icon>mdi-account-tie</v-icon></v-list-item-icon>
                <v-list-item-content><v-list-item-title>Landlords</v-list-item-title></v-list-item-content>
              </v-list-item>

              <v-list-item @click="menuActionClick('activities')">
                <v-list-item-icon><v-icon>mdi-history</v-icon></v-list-item-icon>
                <v-list-item-content><v-list-item-title>Activities</v-list-item-title></v-list-item-content>
              </v-list-item>

              <v-list-item @click="menuActionClick('LeaseReports')">
                <v-list-item-icon><v-icon>mdi-chart-line</v-icon></v-list-item-icon>
                <v-list-item-content><v-list-item-title>Reports</v-list-item-title></v-list-item-content>
              </v-list-item>
            </template>

            <!-- LOGOUT -->
            <v-list-item @click="logout()" class="mt-12">
              <v-list-item-icon><v-icon color="red">mdi-logout</v-icon></v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title style="color: red; font-weight: bold;">Logout</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-col>
      </v-row>
    </v-navigation-drawer>

    <!-- TOP BAR -->
    <v-app-bar app elevation="3" color="white">
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title class="font-weight-bold teal--text text--darken-2">
        {{ pageName }}
      </v-toolbar-title>
      <v-spacer></v-spacer>

      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on">
            <v-avatar size="42">
              <v-icon color="#008080">mdi-account-circle</v-icon>
            </v-avatar>
          </v-btn>
        </template>
        <v-card width="320" class="pa-4">
          <div class="text-center">
            <v-avatar size="90" color="#008080">
              <v-icon size="60" color="white">mdi-account-circle</v-icon>
            </v-avatar>
            <h3 class="mt-3">{{ userName }}</h3>
            <v-chip class="mt-2" small color="#008080" dark>{{ userRole }}</v-chip>
          </div>
          <v-divider class="my-4"></v-divider>
          <v-btn block color="red" dark @click="logout">
            <v-icon left>mdi-logout</v-icon> Logout
          </v-btn>
        </v-card>
      </v-menu>
    </v-app-bar>
  </div>
</template>
<script>
import { getFirestore } from "firebase/firestore";
import { firebaseApp } from "../firebaseConfig";
import { logEvent } from "@/utils/logEvent";  // ← Central audit trail

const db = getFirestore(firebaseApp);

export default {
  data() {
    return {
      drawer: true,
      clickedItem: 0,
      currentUser: null,
    };
  },

  computed: {
    userName() {
      if (!this.currentUser) return "Admin User";
      return `${this.currentUser.name || ""} ${this.currentUser.lastname || this.currentUser.surname || ""}`.trim() || "User";
    },

    userRole() {
      if (!this.currentUser?.roles) return "Admin";
      if (this.currentUser.roles.includes("super admin")) return "Super Admin";
      if (this.currentUser.roles.includes("admin")) return "Admin";
      return this.currentUser.roles.join(", ");
    },

    isSuperAdmin() {
      return Array.isArray(this.currentUser?.roles) && 
             this.currentUser.roles.includes("super admin");
    },

    pageName() {
      const map = {
        '/dashboard': 'Dashboard',
        '/properties': 'Properties',
        '/lease': 'Leases',
        '/tenants': 'Tenants',
        '/landlords': 'Landlords',
        '/activities': 'Activities Log',
        '/LeaseReports': 'Reports',
        '/CreateTemplates': 'Templates',
        '/Users': 'Users Management',
      };
      return map[this.$route.path] || "Property Management";
    }
  },

  created() {
    const user = localStorage.getItem("currentUser");
    this.currentUser = user ? JSON.parse(user) : null;

    // Redirect to login if not authenticated
    if (!this.currentUser && this.$route.path !== '/') {
      this.$router.push('/');
    }
  },

  methods: {
    menuActionClick(action) {
      const routes = {
        dashboard: '/dashboard',
        properties: '/properties',
        lease: '/lease',
        tenants: '/tenants',
        landlords: '/landlords',
        activities: '/activities',
        LeaseReports: '/LeaseReports',
        CreateTemplates: '/CreateTemplates',
        Users: '/Users',
      };

      const path = routes[action];
      if (path && this.$route.path !== path) {
        this.$router.push(path);
      }
    },

    async logout() {
      const userEmail = this.currentUser?.email || this.currentUser?.mobile || "Unknown";

      // Log the logout event using your centralized function
      await logEvent(
        "User Logged Out",
        userEmail,
        "Authentication"
      );

      // Clear session
      localStorage.clear();

      // Redirect to login + force reload to fully reset app state
      this.$router.push('/').then(() => {
        window.location.reload();
      });
    }
  }
};
</script>

<style scoped>
.drawer {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
}

.v-list-item--active {
  background-color: rgba(0, 128, 128, 0.12) !important;
  border-left: 5px solid #008080 !important;
  border-radius: 0 10px 10px 0;
}

.v-list-item {
  border-radius: 0 15px 15px 0;
  margin: 4px 8px;
}
</style>